import { useState, useEffect } from 'react';
import { isAuthenticated } from '../utils/auth';
import LoginForm from '../components/auth/LoginForm';
import RegisterForm from '../components/auth/RegisterForm';

function Auth() {
    const [isLogin, setIsLogin] = useState(true);
    try {

        useEffect(() => {
            if (isAuthenticated()) {
                window.location.href = '/books';
            }

            // Check if the URL has a register parameter
            const urlParams = new URLSearchParams(window.location.search);
            if (urlParams.get('register') === 'true') {
                setIsLogin(false);
            }
        }, []);

        const toggleForm = () => {
            setIsLogin(!isLogin);
        };

        return (
            <div className="min-h-screen bg-gray-50 py-12" data-name="auth-page">
                <div className="container mx-auto px-4">
                    {isLogin ? (
                        <LoginForm onToggleForm={toggleForm} />
                    ) : (
                        <RegisterForm onToggleForm={toggleForm} />
                    )}
                </div>
            </div>
        );
    } catch (error) {
        console.error('Auth page error:', error);
        reportError(error);
        return null;
    }
}

export default Auth;